import { render, staticRenderFns } from "./MobileHome.html?vue&type=template&id=2f7a2ac9&scoped=true&lang=html&"
import script from "./index.vue?vue&type=script&lang=ts&"
export * from "./index.vue?vue&type=script&lang=ts&"
import style0 from "./MobileHome.scss?vue&type=style&index=0&id=2f7a2ac9&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f7a2ac9",
  null
  
)

export default component.exports